import React, { useEffect, useState } from 'react';
import { DatePicker, Image, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { presets } from '../../../utils/RangePickerPresets.js';
import { useSelector } from 'react-redux';
import { GetIBDashboardByIdApi, GetIBOverviewApi, GetMySubIbApi, GetTeamPerformanceApi } from '../../../api/request/ib/ibDashboard.js';
import moment from 'moment';
import dayjs from 'dayjs';
import { Avatar, List } from 'antd';
import TodayEarning from '../../../assets/TodayEarning.jsx';
import TodayLots from '../../../assets/TodayLots.jsx';
import MySignup from '../../../assets/MySignup.jsx';
import AreaChart from '../../../components/charts/charts/AreaChart.jsx';
import TransactionData from './components/TransactionData.jsx';
import Deposit from '../../../assets/user/Deposit.jsx';
import Withdraw from '../../../assets/user/Withdraw.jsx';
import Clock from '../../../assets/user/Clock.jsx';
import CompleteTick from '../../../assets/user/CompleteTick.jsx';
import { getInitials } from '../../../utils/utils.js';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import columns from '../../../columns/topScorer.jsx';

const { RangePicker } = DatePicker;

const IBDashboard = () => {

    const { userDetails } = useSelector(state => state.user);
    const navigate = useNavigate();
    const [value, setValue] = useState('Top');
    const [isTeamPerformanceLoading, setIsTeamPerformanceLoading] = useState(false);
    const [isSubIbLoading, setIsSubIbLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isOverViewLoading, setIsOverViewLoading] = useState(false);
    const [overviewRange, setOverviewRange] = useState({ from: moment(new Date()).subtract(6, 'days').format('MM/DD/YYYY'), to: moment(new Date()).format('MM/DD/YYYY') });
    const [teamPerformanceRange, setTeamPerformanceRange] = useState({ from: moment(new Date()).subtract(6, 'days').format('MM/DD/YYYY'), to: moment(new Date()).format('MM/DD/YYYY') });
    const [overview, setOverview] = useState([]);
    const [data, setData] = useState([]);
    const primaryColor = (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim()
    const secondary = (getComputedStyle(document.documentElement).getPropertyValue('--theme2'))?.trim();
    const [cards, setCards] = useState([]);
    const [teamPerformance, setTeamPerformance] = useState([]);
    const [subIb, setSubIb] = useState([]);
    let currentDate = moment(new Date()).format('YYYY/MM/DD');
    let dateBefore6Days = moment(new Date()).subtract(6, 'days').format('YYYY/MM/DD');

    const getIbDashboard = async () => {
        try {
            setIsLoading(true);
            const { data } = await GetIBDashboardByIdApi();
            if (data?.success) {
                setData(data?.data);
                setCards([
                    { title: 'Today Earning', value: `$ ${data?.data?.todayEarning}`, icon: <TodayEarning fill="#7367F0" />, url: '/ib/commission?filter=today', backgroundColor: "bg-[#E9E7FD]" },
                    { title: 'Today Lots', value: `${data?.data?.todayLot}`, icon: <TodayLots fill="#00BAD1" />, url: '/ib/commission?filter=today', secondary: true, backgroundColor: 'bg-[#D6F4F8]' },
                    { title: 'My Team', value: `${data?.data?.totalSignUp}`, icon: <MySignup fill="#FF9F43" />, url: '/ib/my_trader_team', backgroundColor: 'bg-[#FFF0E1]' },
                    // { title: 'Available IB Commission', value: `$ ${data?.data?.ibAvlCommision}`, icon: '/assets/icons/available-ib-commission.svg', secondary: true },
                ])
            }
            setIsLoading(false);
        } catch (error) { }
    }

    const getIbOverView = async () => {
        try {
            setIsOverViewLoading(true);
            let params = {
                FromDate: overviewRange?.from,
                ToDate: overviewRange?.to,
            }
            const { data } = await GetIBOverviewApi(new URLSearchParams(params).toString());
            if (data?.success) {
                let lotData = [];
                let commissionData = [];
                let dateData = [];
                data?.data?.map((item) => {
                    lotData?.push(item?.lot);
                    commissionData?.push(item?.commission);
                    dateData?.push(moment(item.dateTime).format('MMM DD'));
                })
                setOverview({ categories: dateData, series: [{ name: 'Total Lot', data: lotData }, { name: 'Total Commission', data: commissionData, prefix: '$', postfix: '' }] });
                // setOverview(renameKeys(data?.data, { lot: 'loss', commission: 'profit', dateTime: 'date' }));
            }
            setIsOverViewLoading(false);
        } catch (error) { }
    }

    const getSubIb = async () => {
        try {
            setIsSubIbLoading(true);
            let params = {
                UserId: userDetails?._id,
                filterkeyword: value
            }
            const { data } = await GetMySubIbApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setSubIb(data?.data.map(item => {
                    return {
                        ...item,
                        commision: `$ ${item.commision}`,
                    }
                }));
            }
            setIsSubIbLoading(false);
        } catch (error) { }
    }

    const getTeamPerformance = async () => {
        try {
            setIsTeamPerformanceLoading(true);
            let params = {
                UserId: userDetails?._id,
                FromDate: teamPerformanceRange?.from,
                ToDate: teamPerformanceRange?.to,
            }
            const { data } = await GetTeamPerformanceApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setTeamPerformance(data?.data.map(item => {
                    return {
                        ...item,
                        commision: `$ ${item.commision}`,
                    }
                }));
            }
            setIsTeamPerformanceLoading(false);
        } catch (error) { }
    }

    useEffect(() => {
        getIbDashboard();
    }, []);

    useEffect(() => {
        getIbOverView();
    }, [overviewRange]);

    useEffect(() => {
        getSubIb();
    }, [value]);

    useEffect(() => {
        getTeamPerformance();
    }, [teamPerformanceRange]);

    const calculatePercentage = (a, b) => {
        const total = a + b;
        const percentageA = (a / total) * 100;
        return (percentageA.toFixed(2) + '%').toString();
    }

    const disabled7DaysDate = (current, { from }) => {
        if (from) {
            return Math.abs(current.diff(from, 'days')) >= 7;
        }
        return false;
    };

    const handleDateChange = (value, type) => {
        if (value && value?.length === 2) {
            const fromDate = value[0].format('MM/DD/YYYY');
            const toDate = value[1].format('MM/DD/YYYY');
            if (type == 'Overview') {
                setOverviewRange({ from: fromDate, to: toDate });
            }
            if (type == 'MyTeamPerformance') {
                setTeamPerformanceRange({ from: fromDate, to: toDate });
            }
        }
        if (!value || value?.length === 0) {
            if (type == 'Overview') {
                setOverviewRange({ from: '', to: '' });
            }
            if (type == 'MyTeamPerformance') {
                setTeamPerformanceRange({ from: '', to: '' });
            }
        }
    };


    const KycDetail = [
        { name: 'Complete', count: data?.kycCompleted, icon: <CompleteTick color="#7367F0" />, bgColor: "bg-[#E9E7FD]", color: '#7367F0' },
        { name: 'Pending', count: data?.kycPending, icon: <Clock color="#FF9F43" />, bgColor: "bg-[#FFF0E1]", color: '#FF9F43' },
    ]

    const LiveAccount = [
        { name: 'Complete', count: data?.liveAccCompleted, icon: <CompleteTick color="#00BAD1" />, bgColor: "bg-[#D6F4F8]", color: '#00BAD1' },
        { name: 'Pending', count: data?.liveAccPending, icon: <Clock color="#FF9F43" />, bgColor: "bg-[#FFF0E1]", color: '#FF9F43' },
    ]

    const ActiveTrader = [
        { name: 'Active', count: data?.activeTraders, icon: <CompleteTick color="#28C76F" />, bgColor: "bg-[#DDF6E8]", color: '#28C76F' },
        { name: 'Inactive', count: data?.inActiveTraders, icon: <Clock color="#FF9F43" />, bgColor: "bg-[#FFF0E1]", color: '#FF9F43' },
    ]

    const Deposit = [
        { name: 'Complete', count: data?.depositCompleted, icon: <CompleteTick color="#00727d" />, bgColor: "bg-[#E5F1F2]", color: '#00727d' },
        { name: 'Pending', count: data?.depositPending, icon: <Clock color="#FF9F43" />, bgColor: "bg-[#FFF0E1]", color: '#FF9F43' },
    ]


    return (
        <div>
            {
                isLoading ? (
                    <div className="flex justify-center flex-col mt-[20%]">
                        <Spin size="large" />
                        <p className="primary text-center mt-2">Loading...</p>
                    </div>
                ) : (
                    <div className='mt-3'>
                        <div className='grid xl:grid-cols-3 gap-5'>
                            <div className='xl:col-span-2 border-2 border-light rounded-xl p-5'>
                                <div className='flex flex-col justify-between gap-5 h-full'>
                                    <div>
                                        <div className='flex items-end gap-1'>
                                            <p className='text-xl font-medium'>Welcome back,</p>
                                            <p className='text-lg leading-[1.5]'>{userDetails?.fullName}</p>
                                        </div>
                                        <p className='text-gray-500 mt-1'>Your progress this week is Awesome. let's keep it up and get a lot of commission !</p>
                                    </div>
                                    <div className='grid sm:grid-cols-3 gap-5'>
                                        {
                                            cards?.map((card, index) => (
                                                <div className='rounded-xl' key={index}>
                                                    <div className='flex gap-5 items-center'>
                                                        <div className={`flex justify-center items-center ${card?.backgroundColor || 'bg-primary'} w-[50px] h-[50px] rounded-lg p-2`}>
                                                            {card?.icon}
                                                        </div>
                                                        <div>
                                                            <p className='sm:text-xl text-md'>{card?.value}</p>
                                                            <p className='text-sm text-gray-500 font-medium capitalize'>{card?.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='xl:col-span-1 border-2 border-light rounded-xl p-5'>
                                <div className='flex items-center justify-between gap-5 h-full'>
                                    <div className='flex flex-col justify-between gap-2 h-full'>
                                        <div>
                                            <h3 className='text-xl font-medium'>IB Wallet</h3>
                                            <h6 className='text-gray-500 mt-1'> Available IB Commission</h6>
                                        </div>
                                        <div>
                                            <p className='sm:text-2xl text-lg font-semibold primary'>$ {data?.ibAvlCommision || '00'}</p>
                                        </div>
                                        <div>
                                            <button
                                                className='bg-primary text-sm text-white font-semibold px-4 py-2 rounded-lg'
                                                onClick={() => navigate('/ib/withdraw')}
                                            >
                                                Withdraw
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <Image preview={false} src='/assets/images/userWallet.png' height={"150px"} alt='wallet-img' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='grid md:grid-cols-2 xl:grid-cols-4 gap-5 mt-5'>
                            <div className='border-2 border-light rounded-[10px] p-5 h-fit '>
                                <TransactionData data={Deposit} title={"Deposit"} />
                            </div>
                            <div className='border-2 border-light rounded-[10px] p-5 h-fit cursor-pointer' onClick={() => navigate('/ib/kyc_manager')}>
                                <TransactionData data={KycDetail} title={"KYC Details"} />
                            </div>
                            <div className='border-2 border-light rounded-[10px] p-5 h-fit cursor-pointer' onClick={() => navigate('/ib/live_account')}>
                                <TransactionData data={LiveAccount} title={"Live Account"} />
                            </div>
                            <div className='border-2 border-light rounded-[10px] p-5 h-fit cursor-pointer' onClick={() => navigate('/ib/my_trader_team')}>
                                <TransactionData data={ActiveTrader} title={"Active Trader"} />
                            </div>
                        </div>

                        <div className='grid xl:grid-cols-3 grid-cols-1 gap-5 mt-5'>
                            <div className='xl:col-span-2 border-2 border-light rounded-xl'>
                                <div className='p-5'>
                                    <div className='flex flex-wrap sm:gap-0 gap-3 justify-between items-center h-full'>
                                        <div className='flex items-center'>
                                            <div className='flex items-center'><div className='h-[10px] w-[10px] bg-secondary rounded-[50%]'></div><p className='ml-2 text-sm font-medium text-[#07111CCC]'>Lot</p></div>
                                            <div className='flex items-center ml-3'><div className='h-[10px] w-[10px] bg-primary rounded-[50%]'></div><p className='ml-2 text-sm font-medium text-[#07111CCC]'>Commission</p></div>
                                        </div>
                                        <div className='ant-date-range-selector-white'>
                                            <RangePicker disabledDate={disabled7DaysDate} className='border-primary my-[2px] py-2' onChange={(value) => handleDateChange(value, 'Overview')} defaultValue={[dayjs(dateBefore6Days, 'YYYY/MM/DD'), dayjs(currentDate, 'YYYY/MM/DD')]} presets={presets} format='DD-MM-YYYY' />
                                        </div>
                                    </div>
                                </div>

                                {
                                    isOverViewLoading ? (
                                        <div className="flex justify-center flex-col my-[20%]">
                                            <Spin size="large" />
                                            <p className="primary text-center mt-2">Loading...</p>
                                        </div>
                                    ) : (
                                        <AreaChart data={overview} colors={[secondary, primaryColor]} />
                                    )
                                }
                            </div>

                            <div className='xl:col-span-1 border-2 border-light rounded-xl p-5'>
                                <p className='text-xl font-medium'>Top Scorer</p>

                                <div className="h-[400px] overflow-y-scroll scrollbar-hide space-y-5 mt-5">
                                    <TableWithSkeleton columns={columns} data={data?.topCommissionUsers} />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default IBDashboard;
